import { trackUsage } from '../../../deferred/analytics/NavUsageTrackers';
import getCurrentApp from '../../../utils/getCurrentApp';
export const HELP_NOTIFICATION_DISPLAY_TYPE = {
  RECEIVE_NOTIFICATION: 'receiveNotification',
  RECEIVE_CHAT_MESSAGE: 'receiveChatMessage'
};
export const trackHelpNotificationDisplay = displayType => {
  trackUsage('Help Notification Indicator Displays', {
    class: 'view',
    action: 'helpNotificationDisplay',
    currentApp: getCurrentApp(),
    category: displayType
  });
};
export const trackHelpNotificationDismiss = () => {
  trackUsage('Help Notification Indicator Dismiss', {
    class: 'view',
    action: 'helpNotificationDismiss',
    currentApp: getCurrentApp()
  });
};